import { render, staticRenderFns } from "./FetchingDataSpinner.vue?vue&type=template&id=6a3075c1&"
import script from "./FetchingDataSpinner.vue?vue&type=script&lang=js&"
export * from "./FetchingDataSpinner.vue?vue&type=script&lang=js&"
import style0 from "./FetchingDataSpinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports